import { functions, db } from '../firebase';
import { httpsCallable } from 'firebase/functions';
import { doc, getDoc } from 'firebase/firestore';

import type { StudentDataPolicy } from './adminOrganizations';

export interface OrganizationData {
  name: string;
  /** Which data fields the org collects from students - absent = collected. */
  studentDataPolicy?: StudentDataPolicy;
  profileImageUrl?: string;
  /** Optional light-ink variant, for the sidebar in dark mode. */
  profileImageUrlDark?: string;
  appIconUrl?: string;
  appIconUrlDark?: string;
}

// Get organization data
export const getOrganization = async (organizationId: string): Promise<OrganizationData | null> => {
  try {
    const orgDoc = await getDoc(doc(db, 'organizations', organizationId));
    if (orgDoc.exists()) {
      return orgDoc.data() as OrganizationData;
    }
    return null;
  } catch (error) {
    console.error('Error fetching organization:', error);
    throw error;
  }
};

// Update organization via Cloud Function
export const updateOrganization = async (
  organizationId: string, 
  updates: Partial<OrganizationData>
): Promise<void> => {
  try {
    const updateOrgFunction = httpsCallable(functions, 'updateOrganization');
    await updateOrgFunction({
      organizationId,
      ...updates
    });
  } catch (error) {
    console.error('Error updating organization:', error);
    throw error;
  }
};